/**
 * The state of an asynchronous action that is being performed by a component
 *
 * @internal
 */
export enum AsyncActionState {
  IDLE = 'idle',
  ACTIVE = 'active',
  COMPLETE = 'complete',
  ERROR = 'error'
}
